module.exports = __webpack_public_path__ + "img/2-8-4.097efde2.png";